import styled from 'styled-components'
import { colors, settings, shadows } from 'ThemeStyle'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.white};
  border-radius: ${settings.blockBorderRadius};
  box-shadow: ${shadows.small};
  transition: all 0.6s ease;

  &:hover {
    box-shadow: ${shadows.medium};
  }
`

export const FiltersBar = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 25px;
`
